import React from 'react';
import { LazySection } from './LazySection';
export function SocialProof() {
  return <LazySection className="!bg-ink text-cream !py-[60px]" data-id="element-307">
      <div className="container-wide" data-id="element-308">
        <div className="text-center mb-10" data-id="element-309">
          <h3 className="text-[22px] mb-2 text-cream font-serif" data-id="element-310">
            Un sistema completo. No un ebook más.
          </h3>
          <p className="text-cream/70 text-base max-w-[600px] mx-auto" data-id="element-311">
            Material operativo para trabajar la{' '}
            <span className="highlight-keyword-light" data-id="element-312">raíz</span> — no teoría,
            no afirmaciones, no más de lo mismo.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-[30px] max-w-[900px] mx-auto mb-[50px]" data-id="element-313">
          <div className="text-center" data-id="element-314">
            <div className="font-serif text-[clamp(38px,5vw,56px)] text-gold-light font-medium leading-none mb-2" data-id="element-315">
              6
            </div>
            <div className="text-[13px] text-cream/70 tracking-[0.03em] leading-snug" data-id="element-316">
              módulos del sistema
            </div>
          </div>
          <div className="text-center" data-id="element-317">
            <div className="font-serif text-[clamp(38px,5vw,56px)] text-gold-light font-medium leading-none mb-2" data-id="element-318">
              3
            </div>
            <div className="text-[13px] text-cream/70 tracking-[0.03em] leading-snug" data-id="element-319">
              generaciones que trazás
            </div>
          </div>
          <div className="text-center" data-id="element-320">
            <div className="font-serif text-[clamp(38px,5vw,56px)] text-gold-light font-medium leading-none mb-2" data-id="element-321">
              +40
            </div>
            <div className="text-[13px] text-cream/70 tracking-[0.03em] leading-snug" data-id="element-322">
              ejercicios guiados
            </div>
          </div>
          <div className="text-center" data-id="element-323">
            <div className="font-serif text-[clamp(38px,5vw,56px)] text-gold-light font-medium leading-none mb-2" data-id="element-324">
              2
            </div>
            <div className="text-[13px] text-cream/70 tracking-[0.03em] leading-snug" data-id="element-325">
              estudios científicos
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-[1080px] mx-auto" data-id="element-326">
          <div className="bg-white/5 border border-cream/10 rounded-[14px] p-6" data-id="element-327">
            <div className="text-gold-light text-sm tracking-[2px] mb-3" data-id="element-328">
              ★ ★ ★ ★ ★
            </div>
            <p className="font-serif italic text-cream text-base leading-relaxed mb-3.5" data-id="element-329">
              "Ponerle nombre al{' '}
              <span className="highlight-keyword-light" data-id="element-330">patrón</span> fue el
              primer paso de mi liberación."
            </p>
            <div className="text-xs text-cream/55 tracking-[0.02em]" data-id="element-331">
              <strong className="text-gold-light font-medium" data-id="element-332">
                Review verificada
              </strong>{' '}
              · Amazon — libro de psicología transgeneracional
            </div>
          </div>

          <div className="bg-white/5 border border-cream/10 rounded-[14px] p-6" data-id="element-333">
            <div className="text-gold-light text-sm tracking-[2px] mb-3" data-id="element-334">
              ★ ★ ★ ★ ★
            </div>
            <p className="font-serif italic text-cream text-base leading-relaxed mb-3.5" data-id="element-335">
              "Cuando entendí que no era mío, algo se alivió en mí. No era culpa
              mía."
            </p>
            <div className="text-xs text-cream/55 tracking-[0.02em]" data-id="element-336">
              <strong className="text-gold-light font-medium" data-id="element-337">
                Testimonio
              </strong>{' '}
              · Foro de psicología en español
            </div>
          </div>

          <div className="bg-white/5 border border-cream/10 rounded-[14px] p-6" data-id="element-338">
            <div className="text-gold-light text-sm tracking-[2px] mb-3" data-id="element-339">
              ★ ★ ★ ★ ★
            </div>
            <p className="font-serif italic text-cream text-base leading-relaxed mb-3.5" data-id="element-340">
              "Llevo dos años en terapia y sigo eligiendo lo mismo. Nadie me
              explicó que podía ser algo que venía de antes de mí."
            </p>
            <div className="text-xs text-cream/55 tracking-[0.02em]" data-id="element-341">
              <strong className="text-gold-light font-medium" data-id="element-342">
                Testimonio citado
              </strong>{' '}
              · Nelaosorio.es
            </div>
          </div>
        </div>
      </div>
    </LazySection>;
}